import { ApiResponseData, api } from '~shared/api';

import { routes } from './routes';
import { ApiVoucherCheckResponse, ApiVoucherDetailData, getData } from './types';

export const getParentVoucherDetail = async (data: getData) => {
  let response;

  try {
    response = await api.post<any, ApiResponseData<ApiVoucherDetailData>>(
      routes.getVoucherDetail(),
      { ...data }
    );

    return response.data.timesheet;
  } catch (error) {
    console.error('Error fetching voucher detail:', error);
    throw error;
  }
};

export const checkParentVoucher = async (): Promise<boolean> => {
  try {
    const response = await api.get<any, ApiResponseData<ApiVoucherCheckResponse>>(
      routes.checkVoucher()
    );

    return response.data?.hasVoucher ?? false;
  } catch {
    return false;
  }
};
